(function() {
  if (window.__promoOfferInitialized) return;
  window.__promoOfferInitialized = true;

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function(resolve, reject) {
      try {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  function showToast(root) {
    var toast = root.querySelector('.promo-offer__toast');
    if (!toast) return;
    toast.classList.add('is-visible');
    setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 1000);
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.promo-offer__copy-btn');
    if (!btn) return;
    var text = btn.getAttribute('data-promo-copy') || '';
    if (!text) return;
    var root = btn.closest('.promo-offer');
    copyText(text).then(function() {
      showToast(root || document);
    }).catch(function() {
      showToast(root || document);
    });
  });
})();

